import React from 'react';
import { ResponseStatusAvatar, responseStatusAdminId } from '../../workAvailability/ResponseStatusProvider';
import ChatMessageRow from './ChatMessageRow';
import ChatLinkPreviewList from './ChatLinkPreviewList';
import ChatQuestionCard from '../questions/ChatQuestionCard';
import ChatWorkAvailabilityNotices from './ChatWorkAvailabilityNotices';

export default function IndividualStandardMessageRow({
  message,
  variant = 'plain',
  preset,
  isSelf = false,
  senderName = '',
  senderContent = null,
  showSender = false,
  readCount = 0,
  readLabel = '既読',
  timeLabel = '',
  bubbleClassName = '',
  metaClassName = '',
  rowClassName = '',
  metaExtra = null,
  metaEndContent = null,
  avatarNode = null,
  activeAnchorMessageId = '',
  anchorClassName = 'is-anchor-hit',
  onContextMenu,
  onTouchStart,
  onTouchEnd,
  onTouchCancel,
  onTouchMove,
  sideActionContent = null,
  renderMessageContent,
  afterContent = null,
  footerContent = null,
}) {
  const linkPreviewCards = message?.linkPreview || message?.linkPreviews?.length
    ? <ChatLinkPreviewList message={message} />
    : null;
  const questionCard = message?.question ? <ChatQuestionCard question={message.question} /> : null;
  const hasAvailabilityNotice = Array.isArray(message?.work_availability_notices)
    ? message.work_availability_notices.length > 0
    : Array.isArray(message?.workAvailabilityNotices) && message.workAvailabilityNotices.length > 0;
  const availabilityNotice = hasAvailabilityNotice ? <ChatWorkAvailabilityNotices message={message} /> : null;
  const mergedFooter = (linkPreviewCards || questionCard || footerContent || availabilityNotice)
    ? (<>{linkPreviewCards}{questionCard}{availabilityNotice}{footerContent}</>)
    : null;
  return (
    <ChatMessageRow
      topicMessage={message}
      key={message?.id}
      variant={variant}
      preset={preset}
      isSelf={isSelf}
      messageId={message?.id}
      senderName={senderName}
      senderContent={senderContent}
      showSender={showSender}
      readCount={readCount}
      readLabel={readLabel}
      timeLabel={timeLabel}
      bubbleClassName={bubbleClassName}
      metaClassName={metaClassName}
      rowClassName={rowClassName}
      metaExtra={metaExtra}
      metaEndContent={metaEndContent}
      avatarNode={avatarNode ? <ResponseStatusAvatar adminUserId={responseStatusAdminId(message)} badgePlacement="avatar">{avatarNode}</ResponseStatusAvatar> : null}
      anchorActive={String(activeAnchorMessageId) === String(message?.id)}
      anchorClassName={anchorClassName}
      onContextMenu={onContextMenu}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
      onTouchCancel={onTouchCancel}
      onTouchMove={onTouchMove}
      sideActionContent={sideActionContent}
      footerContent={mergedFooter}
    >
      {typeof renderMessageContent === 'function' ? renderMessageContent(message) : null}
      {afterContent}
    </ChatMessageRow>
  );
}
